/**
 * playBeep — short confirmation tone for barcode scans.
 *
 * On a busy counter the cashier isn't watching the screen; a quick beep (paired
 * with the cart-row flash) confirms the item landed and helps catch double- or
 * missed scans. Uses WebAudio so there's no asset to bundle. A scan is a
 * keyboard event (a user gesture), so the AudioContext is allowed to start.
 */
let ctx: AudioContext | null = null;

export function playBeep(freq = 880, ms = 70): void {
  try {
    const Ctor =
      window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    ctx = ctx ?? new Ctor();
    if (ctx.state === 'suspended') void ctx.resume();
    const now = ctx.currentTime;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    // Quick attack/decay envelope so it's a clean "blip", not a click.
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.14, now + 0.008);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + ms / 1000);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(now);
    osc.stop(now + ms / 1000 + 0.02);
  } catch {
    /* audio unavailable — the visual flash still confirms the scan */
  }
}
